import { createContext, useContext, useState } from "react";

const InvoiceDataContext = createContext();

export const FreelancerInvoiceDataProvider = ({ children }) => {
  const [invoiceItemData, setInvoiceItemData] = useState([]);

  return (
    <InvoiceDataContext.Provider value={{ invoiceItemData, setInvoiceItemData }}>
      {children}
    </InvoiceDataContext.Provider>
  );
};

export const useFLInvoiceDataContext = () => {
  return useContext(InvoiceDataContext);
};